/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface Simulation
 */
export interface Simulation {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly slug?: string;
  /**
   *
   */
  readonly uuid?: string;
  /**
   *
   */
  name: string;
  /**
   * tags provided as a list of strings
   */
  tags?: Array<string>;
  /**
   *
   */
  readonly created?: string;
  /**
   * The id of a threedimodel
   */
  threedimodel: string;
  /**
   * The unique_id of an organisation
   */
  organisation: string;
  /**
   *
   */
  readonly organisationName?: string;
  /**
   * The username of a user
   */
  readonly user?: string;
  /**
   *
   */
  startDatetime: Date;
  /**
   *
   */
  endDatetime?: Date;
  /**
   *
   */
  duration?: number;
  /**
   *
   */
  readonly durationHumanized?: string;
  /**
   *
   */
  readonly threedimodelId?: number;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  threedicoreVersion?: string | null;
  /**
   *
   */
  readonly clonedFrom?: string;
  /**
   * The name of the compute cluster that runs/has run the simulation.
   */
  readonly computeCluster?: string;
  /**
   *
   */
  startedFrom?: string;
  /**
   *
   */
  readonly ranaTenantId?: string | null;
  /**
   * ID of the project in Rana. (only superusers can modify this field)
   */
  readonly ranaProjectId?: string | null;
}

/**
 * Check if a given object implements the Simulation interface.
 */
export function instanceOfSimulation(value: object): value is Simulation {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("threedimodel" in value) || value["threedimodel"] === undefined) return false;
  if (!("organisation" in value) || value["organisation"] === undefined) return false;
  if (
    (!("startDatetime" in (value as Record<string, any>)) &&
      !("start_datetime" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["startDatetime"] === undefined &&
      (value as Record<string, any>)["start_datetime"] === undefined)
  )
    return false;
  return true;
}

export function SimulationFromJSON(json: any): Simulation {
  return SimulationFromJSONTyped(json, false);
}

export function SimulationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Simulation {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    slug: json["slug"] == null ? undefined : json["slug"],
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    name: json["name"],
    tags: json["tags"] == null ? undefined : json["tags"],
    created: json["created"] == null ? undefined : json["created"],
    threedimodel: json["threedimodel"],
    organisation: json["organisation"],
    organisationName: json["organisation_name"] == null ? undefined : json["organisation_name"],
    user: json["user"] == null ? undefined : json["user"],
    startDatetime:
      json["start_datetime"] == null
        ? json["start_datetime"]
        : parseDateTime(json["start_datetime"]),
    endDatetime: json["end_datetime"] == null ? undefined : parseDateTime(json["end_datetime"]),
    duration: json["duration"] == null ? undefined : json["duration"],
    durationHumanized: json["duration_humanized"] == null ? undefined : json["duration_humanized"],
    threedimodelId: json["threedimodel_id"] == null ? undefined : json["threedimodel_id"],
    id: json["id"] == null ? undefined : json["id"],
    threedicoreVersion:
      json["threedicore_version"] === undefined
        ? undefined
        : json["threedicore_version"] === null
        ? null
        : json["threedicore_version"],
    clonedFrom: json["cloned_from"] == null ? undefined : json["cloned_from"],
    computeCluster: json["compute_cluster"] == null ? undefined : json["compute_cluster"],
    startedFrom: json["started_from"] == null ? undefined : json["started_from"],
    ranaTenantId:
      json["rana_tenant_id"] === undefined
        ? undefined
        : json["rana_tenant_id"] === null
        ? null
        : json["rana_tenant_id"],
    ranaProjectId:
      json["rana_project_id"] === undefined
        ? undefined
        : json["rana_project_id"] === null
        ? null
        : json["rana_project_id"],
  };
}

export function SimulationToJSON(json: any): Simulation {
  return SimulationToJSONTyped(json, false);
}

export function SimulationToJSONTyped(
  value?: Omit<
    Simulation,
    | "url"
    | "slug"
    | "uuid"
    | "created"
    | "organisationName"
    | "user"
    | "durationHumanized"
    | "threedimodelId"
    | "id"
    | "clonedFrom"
    | "computeCluster"
    | "ranaTenantId"
    | "ranaProjectId"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    tags: value["tags"],
    threedimodel: value["threedimodel"],
    organisation: value["organisation"],
    start_datetime:
      value["startDatetime"] == null
        ? value["startDatetime"]
        : serializeDateTime(value["startDatetime"]),
    end_datetime:
      value["endDatetime"] == null ? value["endDatetime"] : serializeDateTime(value["endDatetime"]),
    duration: value["duration"],
    threedicore_version: value["threedicoreVersion"],
    started_from: value["startedFrom"],
  };
}
